import React from 'react'
import { useQuery } from 'react-query'
import { useParams, useHistory } from 'react-router-dom'
import { Container, Spinner } from 'react-bootstrap'

import { useApi, useBreakpoint } from '../../../hooks'
import useAppContext from '../../app'
import VehicleHeader from './VehicleHeader'
import AdasSections from './AdasSections'
import SafetyFeatures from './SafetyFeatures'

import './adasReportDetail.css'

const AdasReportDetail = () => {
  const { id } = useParams()
  const history = useHistory()
  const { adasReportService } = useApi()
  const { store: { clientSettings } } = useAppContext()
  const { BREAKPOINT, screenBiggerThan } = useBreakpoint()
  const isBiggerThanXL = screenBiggerThan(BREAKPOINT.XL)

  const allowViewPricing = clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowViewPricing

  const { isLoading, data: report, refetch } = useQuery(
    ['adasReport', id],
    () => adasReportService.get(id).then(res => res.vehicleReport),
    { refetchOnWindowFocus: false }
  )

  if (isLoading || !report) {
    return (
      <Container fluid={!isBiggerThanXL} className='my-5 text-center'>
        <Spinner animation='border' />
      </Container>
    )
  }

  return (
    <Container fluid={!isBiggerThanXL} className='adas-report-detail'>
      <span className='back-link' onClick={() => history.push('/adas-reports')}>
        &larr; Back to Reports
      </span>

      <VehicleHeader report={report} allowViewPricing={allowViewPricing} refetch={refetch} />
      <SafetyFeatures report={report} />
      <AdasSections report={report} allowViewPricing={allowViewPricing} />
    </Container>
  )
}

export default AdasReportDetail
